import { useCallback } from 'react';
import { StyleTemplate } from '../types/template';
import { preloadImages } from '../utils/imageCache';

export const useImagePreloader = () => {
  const preloadTemplateImages = useCallback((templates: StyleTemplate[]) => {
    const imageUrls = templates.map(template => template.imageUrl);
    return preloadImages(imageUrls);
  }, []);

  const preloadBatchImages = useCallback((imageUrls: string[]) => {
    return preloadImages(imageUrls);
  }, []);

  return {
    preloadTemplateImages,
    preloadBatchImages,
  };
};
